import { Avatar, Box, Flex, Text } from "@chakra-ui/react";
import parse from "html-react-parser";
import moment from "moment";
import React from "react";

const AvatarFixed = Avatar as React.ComponentType<{
  name?: string;
  style?: React.CSSProperties;
}>;

interface StreamSidePanelProps {
  type?: string | null;
  resumeId?: string | null;
  data: {
    subject: string;
    body: string;
    to: string;
    cc: string;
    bcc: string;
    recipient_name: string;
    submitted_at: string;
  };
}

export default function StreamSidePanel({
  type,
  resumeId,
  data,
}: StreamSidePanelProps) {
  if (!type || !resumeId) return null;

  return (
    <Box
      style={{ flex: 1, height: "98vh" }}
      overflow={"hidden"}
      backgroundColor={"#FFFFFF"}
      boxShadow={"0 2px 4px 0 rgba(113, 128, 150, 0.15)"}
      borderRadius={"10px"}
    >
      <Flex
        borderBottom={"1px solid #E7EDF4"}
        padding={"16px"}
        height={"80px"}
        justifyContent={"space-between"}
      >
        <Flex gap={"12px"} alignItems={"center"}>
          <AvatarFixed
            name={String(data?.recipient_name ?? "")}
            style={{ width: "48px", height: "48px", fontSize: "16px" }}
          />
          <Flex flexDirection={"column"} alignItems={"flex-start"}>
            <Text color={"#262626"} fontWeight={700} fontSize={"14px"}>
              {data?.recipient_name ?? ""}
            </Text>
            <Text color={"#718096"} fontSize={"14px"} fontWeight={500}>
              {data?.to ?? ""}
            </Text>
          </Flex>
        </Flex>
        <Text color={"#718096"} fontSize={"14px"} fontWeight={500}>
          {data?.submitted_at
            ? moment(data.submitted_at).format("MMM DD, YYYY hh:mm A")
            : ""}
        </Text>
      </Flex>
      <Flex padding={"16px"} height={"54px"} borderBottom={"1px solid #E7EDF4"}>
        <Text color={"#2B2D42"} fontWeight={700} fontSize={"16px"}>
          {data?.subject}
        </Text>
      </Flex>
      <Flex padding={"16px"} height={"calc(100% - 134px)"} overflow={"auto"}>
        <Box
          color={"#2B2D42"}
          fontWeight={500}
          fontSize={"14px"}
          width={"100%"}
          textAlign={"left"}
          sx={{
            "ul, ol": { paddingLeft: "20px" },
          }}
        >
          {data?.body ? parse(data.body) : null}
        </Box>
      </Flex>
    </Box>
  );
}
